import React from 'react';
import Icon from '@ant-design/icons';

const svg = () => (
  <svg width="12" height="14" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.5 3V11.5C10.5 12.3284 9.82843 13 9 13H3C2.17157 13 1.5 12.3284 1.5 11.5V3H10.5Z"
      stroke="#05034D"
    />
    <path
      d="M3.5 3L3.5 2.5C3.5 1.67157 4.17157 1 5 1L7 1C7.82843 1 8.5 1.67157 8.5 2.5L8.5 3L3.5 3Z"
      stroke="#05034D"
    />
    <mask id="path-3-inside-1_21618_66174" fill="white">
      <path d="M0 3C0 2.72386 0.223858 2.5 0.5 2.5H11.5C11.7761 2.5 12 2.72386 12 3C12 3.27614 11.7761 3.5 11.5 3.5H0.5C0.223858 3.5 0 3.27614 0 3Z" />
    </mask>
    <path
      d="M0.5 2.5V4.5H11.5V2.5V0.5H0.5V2.5ZM11.5 3.5V1.5H0.5V3.5V5.5H11.5V3.5ZM0.5 3.5V1.5C1.32843 1.5 2 2.17157 2 3H0H-2C-2 4.38071 -0.88071 5.5 0.5 5.5V3.5ZM12 3H10C10 2.17157 10.6716 1.5 11.5 1.5V3.5V5.5C12.8807 5.5 14 4.38071 14 3H12ZM11.5 2.5V4.5C10.6716 4.5 10 3.82843 10 3H12H14C14 1.61929 12.8807 0.5 11.5 0.5V2.5ZM0.5 2.5V0.5C-0.880712 0.5 -2 1.61929 -2 3H0H2C2 3.82843 1.32843 4.5 0.5 4.5V2.5Z"
      fill="#05034D"
      mask="url(#path-3-inside-1_21618_66174)"
    />
    <rect
      x="4.25"
      y="5.75"
      width="0.5"
      height="4.5"
      rx="0.25"
      fill="#05034D"
      stroke="#05034D"
      strokeWidth="0.5"
    />
    <rect
      x="7.25"
      y="5.75"
      width="0.5"
      height="4.5"
      rx="0.25"
      fill="#05034D"
      stroke="#05034D"
      strokeWidth="0.5"
    />
  </svg>
);

const DeleteIcon3 = (props) => <Icon component={svg} {...props} />;

export default DeleteIcon3;
